import type { Driver, VehicleRoute, VehicleRouteFilters, WebData } from '@cobliteam/api-lib';
import type { DateRange, PageableContent, Sort, UUID, Vehicle, VehicleGroup } from '@cobliteam/common-types';
import { type AppState, loadAddressRequest, loadVehiclesRequest, selectVehiclesWebData } from '@cobliteam/store';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { RoutesHistory } from '../../components';
import { loadVehicleRoutesRequest, selectVehicleRoutes } from '../../store';

interface OwnProps {
  driversById: Map<UUID, Driver>;
  vehiclesById: Map<UUID, Vehicle>;
  vehicleGroupsById: Map<UUID, VehicleGroup>;
  loadPageContent: () => void;
  onSwitchToV2?: () => void;
}

interface StateProps {
  vehicleRoutesPageWebData: WebData<PageableContent<VehicleRoute>>;
  vehiclesWebData: WebData<Vehicle[]>;
}

interface DispatchProps {
  loadOnChanges: (period: DateRange, page: number, size: number, filters?: VehicleRouteFilters, sort?: Sort) => void;
  loadPageContent: () => void;
  onRequestAddress: (latitude: number, longitude: number) => void;
}

const mapStateToProps = (state: AppState): StateProps => ({
  vehicleRoutesPageWebData: selectVehicleRoutes(state),
  vehiclesWebData: selectVehiclesWebData(state),
});

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps): DispatchProps => ({
  loadOnChanges: (period, page, size, filters, sort) => {
    dispatch(loadVehicleRoutesRequest(period, page, size, filters, sort));
  },
  loadPageContent: () => {
    ownProps.loadPageContent();
    dispatch(loadVehiclesRequest());
  },
  onRequestAddress: (latitude, longitude) => dispatch(loadAddressRequest({ latitude, longitude })),
});

const RoutesHistoryContainer = connect<StateProps, DispatchProps, OwnProps, AppState>(mapStateToProps, mapDispatchToProps)(RoutesHistory);

export default RoutesHistoryContainer;
